import { all } from 'redux-saga/effects';
import authSaga from '../modules/auth/sagas';
import userSaga from '../modules/user/sagas';
import { errorsSaga } from '../modules/error/sagas';
import catalogSaga from '../modules/catalog/sagas';
import ordersSaga from '../modules/orders/sagas';
import { refundsSaga } from '../modules/refunds/sagas';
import { balanceSaga } from '../modules/wallet/sagas';
import cartsSaga from '../modules/cart/sagas';

export default function* rootSaga() {
  yield all([
    authSaga(),
    userSaga(),
    balanceSaga(),
    errorsSaga(),
    catalogSaga(),
    cartsSaga(),
    ordersSaga(),
    refundsSaga(),
  ]);
}
